module.exports = __webpack_public_path__ + "img/ico3.4a55881a.png";